import { put, call, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
// import ApiService from '../Services/ApiService';
// import AppActions from '../Stores/App/Actions';
import PalletLabelProcessActions, {
  PalletLabelProcessTypes
} from '../Stores/PalletLabelProcess/Actions';

// const getAppStore = state => state.app;

export function* palletLabelProcessFetchPalletLabelProcess() {
  try {
    yield put(PalletLabelProcessActions.palletLabelProcessFetchPalletLabelProcessLoading(true));

    const result = [{ proc_type: 'PALLET_LABEL_LIST_01', icon: 'fa fa-cubes' }];
    yield put(PalletLabelProcessActions.palletLabelProcessFetchPalletLabelProcessSuccess(result));

    /*
    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `site/indexItemFlow/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );
    
    if (result.isSuccess === true) {
      yield put(PalletLabelProcessActions.palletLabelProcessFetchPalletLabelProcessSuccess(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
    */
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PalletLabelProcessActions.palletLabelProcessFetchPalletLabelProcessLoading(false));
  }
}

export const saga = [
  takeLatest(
    PalletLabelProcessTypes.PALLET_LABEL_PROCESS_FETCH_PALLET_LABEL_PROCESS,
    palletLabelProcessFetchPalletLabelProcess
  )
];
